var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex box mx-1 my-1 mx-lg-0"},[_c('div',{class:[
            'box__left__container d-flex pl-2 py-1',
            {
                'justify-content-center flex-column': !_vm.icon,
                'align-items-center flex-row': _vm.icon,
            },
        ]},[(_vm.icon)?_c('i',{class:[_vm.icon, 'mr-3']}):_vm._e(),_c('span',{staticClass:"box__title"},[_vm._v(_vm._s(_vm.title))]),(!_vm.icon)?_c('span',{staticClass:"box__subtitle"},[_vm._v(_vm._s(_vm.subtitle))]):_vm._e()]),_c('div',{staticClass:"d-flex justify-content-center align-items-center box__info ml-auto"},[_vm._v("\n        "+_vm._s(_vm.info || '-')+"\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }